import React, { useState } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";

export default function SearchGridPagination(props) {
  const [isFetching, setIsFetching] = useState(false);

  const callCsvApi = () => {
    setIsFetching(true);

    axios
      .get(`api/v1/hwts/search/all/csv${props.queryParams}`)
      .then((res) => {
        let date = new Date();
        let filename = `${"HandlerSearchResults"}_${date.toLocaleDateString(
          "en-US"
        )}.csv`;
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //IE11 and the legacy version Edge support
          let blob = new Blob([res.data], {
            type: "csv",
          });
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          // other browsers
          var bl = new Blob([res.data], {
            type: "csv",
          });
          var a = document.createElement("a");
          a.href = URL.createObjectURL(bl);
          a.download = filename;
          a.hidden = true;
          document.body.appendChild(a);
          a.click();
        }
        setIsFetching(false);
      })
      .catch((err) => {
        setIsFetching(false);
      });
  };

  const onNextPageChange = () => {
    const nextPage = props.filters.page + 1;
    props.onPageChange({ page: nextPage });
  };

  const onPreviousPageChange = () => {
    const nextPage = props.filters.page - 1;
    props.onPageChange({ page: nextPage });
  };

  const getPageNumber = () => {
    let pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(props.resultCount / props.filters.pageSize);
      i++
    ) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const getCurrentPage = () => {
    return props.filters.page;
  };

  const getInitPageRange = () => {
    //return this.props.search.page < 3 ? 1 : 3;
    return 1;
  };

  const getLastPage = () => {
    let lastPage = getPageNumber().length - 1;
    return lastPage;
  };

  const style = {
    active: {
      color: "#046B99",
      fontWeight: "bold",
      lineHeight: "6px",
      marginTop: "3px",
      padding: "0.5rem 0.25rem",
      marginLeft: "1px",
    },
    inactive: {
      lineHeight: "6px",
      marginTop: "3px",
      padding: "0.5rem 0.25rem",
      marginLeft: "1px",
    },
  };

  const pageSizeOptions = [
    { name: "10", value: 10 },
    { name: "25", value: 25 },
    { name: "50", value: 50 },
    { name: "100", value: 100 },
  ];

  const pagination = getPageNumber()
    .map((page) => (
      <li className="page-item" key={page}>
        <a
          style={
            getCurrentPage() == page ? style.active : style.inactive
          }
          className="page-link"
          onClick={() => props.onPageChange({ page: page })}
        >
          {page}
        </a>
      </li>
    ))
    .splice(
      (getCurrentPage() > 1
        ? getCurrentPage() - 1
        : getCurrentPage()) - getInitPageRange(),
      8
    );

  if (props.results.total_records === 0) {
    return <div />;
  }

  return (
    <div
      style={{
        textAlign: "center",
        border: "1px solid #bdc3c7",
        marginTop: 0,
        borderTop: "none",
        color: "rgba(0,0,0,.54)",
        fontSize: "14px",
      }}
    >
      <nav aria-label="">
        <button
          className="btn btn-primary"
          style={{
            fontSize: "0.85rem",
            padding: "0.3rem 0.5rem",
            lineHeight: 1,
            position: "relative",
            bottom: -3,
            marginLeft: "5px",
            float: "left",
            minWidth: "90px",
            maxHeight: "25px",
          }}
          onClick={() => callCsvApi()}
          disabled={props.results.total_records > 0 ? false : true}
        >
          {isFetching === true ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              variant="light"
              role="status"
              aria-hidden="true"
              className="test-spinner"
            >
              <span className="sr-only">Loading...</span>
            </Spinner>
          ) : (
              //"Export CSV"
              `Export CSV`
            )}
        </button>
        <ul
          className="pagination"
          style={{
            justifyContent: "flex-end",
            paddingRight: "5px",
            marginBottom: "3px",
          }}
        >
          <li
            className={props.filters.page === 1 ? "page-item disabled" : "page-item"}
            style={{ marginTop: "4px", marginRight: "20px" }}
          >
            <div
              className="test-header"
              style={{
                position: "relative",
                marginRight: "10px",
                width: "200px",
              }}
            >
              Page Size:
                <select
                name={"pageSize"}
                className="m-l-sm"
                onChange={(e) =>
                  props.onSortingChange(e)
                }
                id="page-size"
                defaultValue={props.filters.pageSize}
              >
                {pageSizeOptions.map((d, i) => (
                  <option key={d.value} value={d.value}>
                    {d.name}
                  </option>
                ))}
              </select>
            </div>
          </li>
          <li
            className={props.filters.page === 1 ? "page-item disabled" : "page-item"}
            style={{
              marginTop: "6px",
              marginRight: "50px",
              display: props.resultCount ? "" : "none",
            }}
          >
            Page: {getCurrentPage()} of{" "}
            {Math.ceil(props.resultCount / props.filters.pageSize)}
          </li>
          <li className={props.filters.page === 1 ? "page-item disabled" : "page-item"}>
            <button
              className="btn btn-default"
              style={{
                fontSize: "0.85rem",
                padding: "0.3rem 0.5rem",
                lineHeight: 1,
                position: "relative",
                bottom: -3,
                marginLeft: "10px",
                float: "left",
                borderColor: props.filters.page === 1 ? "lightgray" : "black",
              }}
              onClick={
                props.filters.page === 1 ? null : () => props.onPageChange({ page: 1 })
              }
              disabled={props.filters.page === 1}
            >
              First
              </button>
          </li>
          <li className={props.filters.page === 1 ? "page-item disabled" : "page-item"}>
            <button
              className="btn btn-default"
              style={{
                fontSize: "0.85rem",
                padding: "0.3rem 0.5rem",
                lineHeight: 1,
                position: "relative",
                bottom: -3,
                marginLeft: "5px",
                float: "left",
                borderColor: props.filters.page === 1 ? "lightgray" : "black",
              }}
              onClick={props.filters.page === 1 ? null : onPreviousPageChange}
              disabled={props.filters.page === 1}
            >
              Previous
              </button>
          </li>
          {pagination}
          <li
            className={
              props.filters.page == getLastPage() || props.filters.page == getLastPage() + 1
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="btn btn-default"
              style={{
                fontSize: "0.85rem",
                padding: "0.3rem 0.5rem",
                lineHeight: 1,
                position: "relative",
                bottom: -3,
                marginLeft: "5px",
                float: "left",
                borderColor:
                  props.filters.page === getLastPage() || props.filters.page == getLastPage() + 1
                    ? "lightgray"
                    : "black",
              }}
              onClick={props.filters.page === getLastPage() ? null : onNextPageChange}
              disabled={props.filters.page == getLastPage()}
            >
              Next
            </button>
          </li>
          <li
            className={
              props.filters.page == getLastPage() + 1
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="btn btn-default"
              style={{
                fontSize: "0.85rem",
                padding: "0.3rem 0.5rem",
                lineHeight: 1,
                position: "relative",
                bottom: -3,
                marginLeft: "5px",
                float: "left",
                borderColor:
                  props.filters.page === getLastPage() + 1 ? "lightgray" : "black",
              }}
              onClick={
                props.filters.page === getLastPage() + 1
                  ? null
                  : () =>
                    props.onPageChange({
                      page: getLastPage() + 1,
                    })
              }
              disabled={props.filters.page == getLastPage() + 1}
            >
              Last
              </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
